import { createVerifyCode } from '@frame/utils/Utils'
import store from '@common/entry/store'
import Cookies from 'js-cookie'

require('@frame/utils/BizSecurity.js')
const gsv = window.LOCAL_CONFIG.UC_GSV
const file_gsv = window.LOCAL_CONFIG.FILE_GSV
const bs_gsv = window.LOCAL_CONFIG.BS_GSV
/**
 * 获取公告信息
 * @param type
 * @returns {*}
 */
export function getNotice (type) {
  let params = {
    'page_no': 1,
    'page_size': 500,
    'notice_type': type
  }
  return window.fetch.post(bs_gsv + '/ext/notice/get_basic_notice_info_page_ext', params)
}
/**
 * 获取当前ip
 * @param {*} param
 */
export function getIp (param) {
  return window.fetch.post(file_gsv + '/rest/file/get_ip', param)
}

/**
 * 前台登录
 */
export function doLogin (username, password, checkcode, checktoken, loginType = "") {
  let loginSource = 'web'
  if (window.isElectron) {
    loginSource = 'pc'
  }
  let params = { 'username': username, loginType: loginType, 'loginSource': loginSource, }

  if (loginType) {
    params.smsCode = checkcode
  } else {
    params.password = password
    params.checkcode = checkcode
    params.checktoken = checktoken
  }

  return window.fetch.post(gsv + '/ws/do/login', params)
}
/**
 * 锁屏解锁登录
 */
export function unlockLogin (username, password) {
  let params = {
    'username': username,
    'password': password
  }
  return window.fetch.post(gsv + '/ws/do/un_lock', params)
}
/**
 * 退出登录
 */
export function logout () {
  let loginSource = 'web'
  if (window.isElectron) {
    loginSource = 'pc'
  }
  let clientip = Cookies.get('clientIp')
  let ip_addr = clientip || ''
  let sessionId = store.getters.token || window.localStore.get('token')
  return window.fetch.post(window.LOCAL_CONFIG.UC_GSV + '/ws/do/logout' + '?time=' + new Date().getTime(), { 'ip_addr': ip_addr, 'sessionId': sessionId, 'loginSource': loginSource })
}
/**
 * 图形验证码
 */
export function getCheckCode (option) {
  return createVerifyCode(file_gsv + '/rest/code/create', option)
}

/**
 * 获取菜单信息
 * @param toPath
 * @returns {*}
 */
export function getOtpMenuList (toPath) {
  let isUrlLowercase = window.LOCAL_CONFIG.isUrlLowercase + ''
  let url = '/ws/menu/getMenuTree' + '?time=' + new Date().getTime()
  if (isUrlLowercase === 'true') {
    url = url.toLowerCase()
  }
  // 如果是IAR单点登录，增加前端应用参数和当前页面参数，以供回调时候显示当前页面
  let isIARCasLogin = window.LOCAL_CONFIG.isIARCasLogin + ''
  let lang = window.localStorage.getItem('lang')
  if (isIARCasLogin === 'true') {
    url += '?ssoName=' + window.LOCAL_CONFIG.casSsoName + '&to=' + toPath
  }
  let frontType = 'web'
  if (window.isElectron) {
    frontType = 'pc'
  }
  let sessionId = store.getters.token || window.localStorage.getItem('token')
  return window.fetch.post(window.LOCAL_CONFIG.UC_GSV + url, { 'frontType': frontType, 'lang': lang, 'currSessionId': sessionId })
}
/**
 *获取用户操作权限信息
 */
/**
 * 获取登录信息
 * @returns {*}
 */
export function getCurrUserInfo (option = { refresh: false }) {
  let isUrlLowercase = window.LOCAL_CONFIG.isUrlLowercase + ''
  let url = '/ws/user/getCurrUser'
  if (isUrlLowercase === 'true') {
    url = url.toLowerCase()
  }
  let frontType = 'web'
  if (window.isElectron) {
    frontType = 'pc'
  }
  let sessionId = store.getters.token || window.localStore.get('token')
  let time = new Date().getTime()
  return window.fetch.post(window.LOCAL_CONFIG.UC_GSV + url, { 'frontType': frontType, 'time': time, 'currSessionId': sessionId, refresh: option.refresh })
}

export function casLogout () {

}

export function encryptParam () {

}

export function reLogin () {

}

/**
 * 获取用头像
 * @returns {*}
 */
export function getHeadImg (option) {
  return window.fetch.post(gsv + '/ws/get/head_img', option)
}

/**
 * 发送短信验证码
 * @returns {*}
 */
export function sendPhoneCode (option) {
  return window.fetch.post(gsv + '/ws/user/send_phone_code', option)
}